module.exports = __webpack_public_path__ + "img/Iran.4450d407.png";